/**
 * HTTP security policy service — gateway `/security-policies` endpoints
 * (proxied to taxhive-security-service security_policy_routes).
 *
 * Contract notes (verified against taxhive-security-service security_policy_routes.py):
 *  - Get:    `GET /security-policies`  → SecurityPolicyResponse (defaults applied).
 *  - Update: `PUT /security-policies`  with SecurityPolicyUpdate (partial; any
 *            of password_policy / session_policy / login_policy) → merged policy.
 *
 * NOTE: the gateway proxy for `/security-policies` is added by settings_routes.py
 * (this task).
 */

import { apiClient, toServiceError } from '@/services/http/client'
import type { SecurityPolicyService } from './securityPolicy.service'
import type {
  SecurityPolicy,
  UpdateSecurityPolicyInput,
} from '@/types/securityPolicy.types'
import { mapSecurityPolicyFromApi, mapUpdateToApi } from './mappers'

export function createHttpSecurityPolicyService(): SecurityPolicyService {
  return {
    async get(): Promise<SecurityPolicy> {
      try {
        const res = await apiClient.get('/security-policies')
        return mapSecurityPolicyFromApi(res.data)
      } catch (err) {
        throw toServiceError(err)
      }
    },

    async update(patch: UpdateSecurityPolicyInput): Promise<SecurityPolicy> {
      try {
        const res = await apiClient.put('/security-policies', mapUpdateToApi(patch))
        return mapSecurityPolicyFromApi(res.data)
      } catch (err) {
        throw toServiceError(err)
      }
    },
  }
}
